import { SVGProps, memo } from 'react';
import PDFOffIcon from '../assets/images/pdfoff.png';

const PdfOffIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='19'
    height='18'
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <rect width='19' height='18' fill='url(#pattern0_5450_80012)' />
    <defs>
      <pattern
        id='pattern0_5450_80012'
        patternContentUnits='objectBoundingBox'
        width='1'
        height='1'
      >
        <use
          xlinkHref='#image0_5450_80012'
          transform='matrix(0.00493421 0 0 0.00520833 -0.00328947 0)'
        />
      </pattern>
      <image
        id='image0_5450_80012'
        width='204'
        height='192'
        preserveAspectRatio='none'
        xlinkHref={PDFOffIcon}
      />
    </defs>
  </svg>
);

export default memo(PdfOffIcon);
